var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoriesIcon = function SvgCategoriesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2463EB",
    clipPath: "url(#CategoriesIcon_svg__clip0_6076_75980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.304 23.018h3.893v3.892H6.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M28.334 27.055h-4.206V4.695a.25.25 0 0 0-.25-.25H8.372V.75h19.962z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.304 9.284h3.893v3.893H6.304zM6.304 16.15h3.893v3.893H6.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.503 26.14a.5.5 0 0 1 .5-.5h9.237a.5.5 0 0 1 0 1h-9.237a.5.5 0 0 1-.5-.5m0-2.352a.5.5 0 0 1 .5-.5h3.84a.5.5 0 0 1 0 1h-3.84a.5.5 0 0 1-.5-.5m-4.949-.52h3.393v3.393H6.554zm-.5 4.393h4.393a.5.5 0 0 0 .5-.5v-4.393a.5.5 0 0 0-.5-.5H6.054a.5.5 0 0 0-.5.5v4.393a.5.5 0 0 0 .5.5m5.45-8.387a.5.5 0 0 1 .5-.5h9.236a.5.5 0 0 1 0 1h-9.237a.5.5 0 0 1-.5-.5m0-2.353a.5.5 0 0 1 .5-.5h3.84a.5.5 0 1 1 0 1h-3.84a.5.5 0 0 1-.5-.5m-4.95-.52h3.393v3.393H6.554zm-.5 4.393h4.393a.5.5 0 0 0 .5-.5V15.9a.5.5 0 0 0-.5-.5H6.054a.5.5 0 0 0-.5.5v4.393a.5.5 0 0 0 .5.5m5.45-8.387a.5.5 0 0 1 .5-.5h9.236a.5.5 0 0 1 0 1h-9.237a.5.5 0 0 1-.5-.5m0-2.353a.5.5 0 0 1 .5-.5h3.84a.5.5 0 0 1 0 1h-3.84a.5.5 0 0 1-.5-.5m-4.95-.52h3.393v3.393H6.554zm-.5 4.394h4.393a.5.5 0 0 0 .5-.5V9.035a.5.5 0 0 0-.5-.5H6.054a.5.5 0 0 0-.5.5v4.393a.5.5 0 0 0 .5.5m22.03 12.877V1H8.622v3.195h15.256a.5.5 0 0 1 .5.5v22.11zM23.378 31V5.195H3.916V31zM8.122 0a.5.5 0 0 0-.5.5v3.695H3.416a.5.5 0 0 0-.5.5V31.5a.5.5 0 0 0 .5.5h20.462a.5.5 0 0 0 .5-.5v-3.695h4.206a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgCategoriesIcon;